import logoImg from '../assets/logo_with_name.png';

export default function Footer() {
  return (
    <footer className="footer">
      <img src={logoImg} alt="veremeen" className="footer__logo" />
      <span className="footer__copy">
        © {new Date().getFullYear()} veremeen. All rights reserved.
      </span>
      <a href="mailto:hello@veremeen.com" className="footer__link">
        hello@veremeen.com
      </a>
    </footer>
  );
}
